import { invariant } from '@e-socna/utils';

import { QuotationContextStatus } from '../types/quotation-context.type';

import { useQuotationContext } from './useQuotationContext.hook';

export const useQuotationReadyContext = () => {
  const context = useQuotationContext();

  invariant(
    context.status === QuotationContextStatus.Ready,
    'useQuotationReadyContext requires QuotationContext to be ready',
  );

  return context;
};
